// @en Defines the field name used to pass authorization information in the HTTP request header
export const AUTH_HEADER = "Authorization";

// @en Defines the field name used to specify language preference in the HTTP request header
export const LANG_HEADER = "X-Lang";

// @en Defines the field name used to specify the application name in the HTTP request header
export const APP_NAME_HEADER = "X-App-Name";

// @en Defines the path used to refresh the access token in the HTTP request path
export const REFRESH_TOKEN_PATH = "refresh-token";
